export const totalExpensesCalculator = (expenses) => {



}

export const totalIncomeCalculator = (incomes) => {

    let totalIncome

    const incomesArray = incomes.map(income => {
        return +income.sum;
    })
    if (incomesArray.length > 0) {
        totalIncome = incomesArray.reduce((total, num) => {
            return total + num;
        })
    } else {
        totalIncome = 0;
    }

    return totalIncome

}

export const totalEquityCalculator = (equity) => {

    let totalEquity;

    const equityArray = equity.map(ek => {
        return +ek.sum;
    });
    if (equityArray.length > 0) {
        totalEquity = equityArray.reduce((total, num) => {
            return total + num;
        })
    } else {
        totalEquity = 0;
    }
    return totalEquity


}

export const budgetCalculator = (income, expense) => {

    const totalIncome = income - expense;
    return totalIncome;

}
export const expensesDataCalculator = (expenses) => {

    const matUtgifter = 500;
    const husleie = 2000;
    const multimedia = 2000;
    const telefon = 400;
    const strømmetjenester = 900;
    const annet = 500;

    const data = [matUtgifter, husleie, multimedia, telefon, strømmetjenester, annet];
    console.log(data, "Data expenses")
    return data;
}
